// Default options and scales for climate surveys

import { QuestionOption } from './schema';

// Standard 4-point emoji scale used across all climate surveys
// Aligned with California Healthy Kids Survey format
// Order: Negative to Positive (left to right)
export const EMOJI_SCALE: QuestionOption[] = [
  { value: 'never', label: 'Never', emoji: '☹️' },
  { value: 'sometimes', label: 'Sometimes', emoji: '😐' },
  { value: 'most-of-the-time', label: 'Most of the time', emoji: '😊' },
  { value: 'always', label: 'Always', emoji: '😀' },
];

// Numeric values for reporting/analytics
export const EMOJI_SCALE_VALUES: Record<string, number> = {
  always: 4,
  'most-of-the-time': 3,
  sometimes: 2,
  never: 1,
};

// Number of response types (from highest score down) that count as positive.
//   1 = only "always"
//   2 = "always" + "most of the time"            (top-2 box, CHKS-aligned)
//   3 = adds "sometimes"                          (current setting)
//   4 = all responses count (disables the metric)
// Must match POSITIVE_THRESHOLD in server/config/categoryMapping.ts.
export const POSITIVE_THRESHOLD = 3;

// Derived: response values that count as positive, given the threshold above.
export const POSITIVE_RESPONSES = Object.entries(EMOJI_SCALE_VALUES)
  .sort(([, a], [, b]) => b - a)
  .slice(0, POSITIVE_THRESHOLD)
  .map(([value]) => value);

// Default placeholder for open-ended questions
export const DEFAULT_TEXTAREA_PLACEHOLDER =
  'Type your answer here... (optional)';

// Default branding for surveys
export const DEFAULT_BRANDING = {
  completionTitle: 'Thank You!',
  completionMessage:
    'Your responses have been recorded. Thank you for sharing your thoughts!',
};
